import { Modal } from '@collegebacker/backer-ui/ui'
import classNames from 'classnames'
import { ShareLink } from './ShareLink'
import styles from './ShareLinkModalNew.module.scss'

export const ShareLinkModalNew = ({
  modalRef,
  fund,
  shareSource,
  updateGiftingPage,
  onClose
}: {
  modalRef: any
  fund: {
    fundName: string
    handle: string
    uuid: string
  }
  shareSource: 'gifting page' | 'fund page' | 'fund settings',
  updateGiftingPage?: any,
  onClose?: () => void
}) => {
  return (
    <Modal ref={modalRef} onCloseClick={onClose}>
      <h2 className={'typo-app-title-small'}>
        Share {shareSource !== 'gifting page' ? 'your ' : ''}fund
      </h2>
      <p
        className={classNames('typo-app-body-large-adaptive', styles.subtitle)}
      >
        Share a link to this fund with family and friends.
      </p>
      <ShareLink
        shareSource={shareSource}
        updateGiftingPage={updateGiftingPage}
        fund={fund}
        fundHandle={fund.handle}
      />
    </Modal>
  )
}
